import React, { FunctionComponent, useState } from 'react';

import { ImageExtended, ThumbnailImageProps } from 'react-grid-gallery';

import { GalleryCard } from './AttachmentGallery';
import { GalleryCardOverlay } from './GalleryCardOverlay';
import { GalleryImage } from './GalleryImage';

import classes from './styles/attachment-gallery.module.scss';
import './styles/attachment-gallery.module.scss';

export const ImageComponent: FunctionComponent<ThumbnailImageProps<GalleryCard & ImageExtended>> = ({
  imageProps,
  item
}) => {
  const { handleExpandedViewSelection } = item.item;
  const [downloadButtonActive, setDownloadButtonActive] = useState(false);

  const handleDownloadButtonActive = (state: boolean): void => {
    setDownloadButtonActive(state);
  };

  return (      
    <div 
      aria-hidden='true' 
      className={classes.galleryCard} 
      onBlur={(): void => handleDownloadButtonActive(false)}
      onFocus={(): void => handleDownloadButtonActive(true)}
      onMouseEnter={(): void => handleDownloadButtonActive(true)}
      onMouseLeave={(): void => handleDownloadButtonActive(false)}
    >
      <GalleryCardOverlay
        asset={item.item.asset}
        attachmentId={item.item.attachmentId || null}
        downloadButtonActive={downloadButtonActive}
        handleExpandedViewSelection={handleExpandedViewSelection}
        handleSelection={item.item.handleSelection}
        isSelected={item.item.isSelected}
      />
      <GalleryImage imageProps={imageProps} item={item.item} />
    </div>
  );
};
